import MapHotelCard from './MapHotelCard.component';
export default MapHotelCard;